import loadGoogleMapsApi from '../../utils/loadGoogleMapsApi';
import isZipCode from './is-zip-code';
import { BIAS_RADIUS, GOOGLE_MAPS_API_TIMEOUT } from '../constants';
import predictionAdapter from './prediction-adapter';

let autocompleteService;

function timedReject(timeout) {
    return new Promise((resolve, reject) => setTimeout(reject, timeout));
}

/**
 * Retrieves place predictions from Google Places API.
 * @param {string} input
 * @param {Object} biasPredictionsToCoordinates - location that predictions will be biased towards
 * @param {number} biasPredictionsToCoordinates.lat - the latitude of the bias location
 * @param {number} biasPredictionsToCoordinates.lng - the longitude of the bias location
 *
 * Reference: https://developers.google.com/maps/documentation/javascript/reference#AutocompleteService
 */
export default async function fetchPlacePredictions(input, biasPredictionsToCoordinates) {
    if (!window.google || !window.google.maps) {
        try {
            await Promise.race([loadGoogleMapsApi(), timedReject(GOOGLE_MAPS_API_TIMEOUT)]);
        } catch (e) {
            return Promise.resolve([]);
        }
    }

    if (!autocompleteService) {
        autocompleteService = new window.google.maps.places.AutocompleteService();
    }

    const latLng = new window.google.maps.LatLng(biasPredictionsToCoordinates.lat, biasPredictionsToCoordinates.lng);

    return new Promise(resolve => {
        autocompleteService.getPlacePredictions({
            componentRestrictions: { country: ['us'] },
            input,
            location: latLng,
            radius: BIAS_RADIUS,
            types: isZipCode(input) ? ['(regions)'] : ['geocode'],
        }, (predictions, status) => {
            if (status !== window.google.maps.places.PlacesServiceStatus.OK) { return resolve([]); }

            return resolve(predictions.map(predictionAdapter));
        });
    });
}
